export const calculateAge = (dob) => {
        try {
          if (!dob) return "----";
          const today = new Date();
          const birthdateDate = new Date(dob);

          let calculatedAge = today.getFullYear() - birthdateDate.getFullYear();
          const monthDiff = today.getMonth() - birthdateDate.getMonth();

          if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdateDate.getDate())) {
            calculatedAge--;
          }
          return calculatedAge

        }
        catch (err) {
          return 0
        }

      };